import { render, staticRenderFns } from "./RouteDonut.vue?vue&type=template&id=2c5d2ec4&"
import script from "./RouteDonut.vue?vue&type=script&lang=js&"
export * from "./RouteDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports